module.exports = __webpack_public_path__ + "static/media/9.3d7d8dd6.png";